import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { LanguageCourse } from '../language-course';
import { SchoolService } from '../service/school.service';
import { ToastMessageService } from '../toast-message.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-school-course-edit',
  templateUrl: './school-course-edit.component.html',
  styleUrls: ['./school-course-edit.component.css']
})
export class SchoolCourseEditComponent implements OnInit {

  constructor(
    public schoolService: SchoolService,
    private httpService: HttpService,
    private confirmationService: ConfirmationService,
    private toastService: ToastMessageService,
    private builder: FormBuilder
  ) { }

  ngOnInit(): void {
  }

  deleteCourse(courseForm: any, index: number) {
    this.confirmationService.confirm({
      header: "Delete Course",
      message: "Are you sure to delete this course?: " + courseForm.value.code,
      accept: () => {
        let formArray = this.schoolService.schoolForm.get('courses') as FormArray;
        if (courseForm.value.id) {
          this.httpService.deleteLanguageCourseById(courseForm.value.id).subscribe(() => {
            this.toastService.addSuccess("Success", "Deleted successfully");
            formArray.removeAt(index);
          }, error => {
            this.toastService.addError("Error", error.message);
          });
        } else {
          formArray.removeAt(index);
        }
      }
    });
  }

  addCourse() {
    let courses = this.schoolService.schoolForm.get("courses") as FormArray;
    courses.push(this.builder.group({
      code: null,
      description: null,
      id: null,
      created: null,
      createdBy: null,
      descriptionEn: [null, Validators.required],
      descriptionNl: null,
      descriptionEs: null,
      descriptionPt: null
    }));
  }

  updateCourses() {
    let courses = this.schoolService.schoolForm.get("courses") as FormArray;
    if(courses.invalid){
      this.toastService.addError("Error", "English description is required");
      return;
    }
    this.schoolService.updatingSchool = true;
    let newCourseList = [];

    for (let courseForm of courses.controls) {
      if (courseForm.value.code && courseForm.value.code != "") {
        newCourseList.push(
          new LanguageCourse(
            courseForm.value.code,
            courseForm.value.description,
            courseForm.value.descriptionEn,
            courseForm.value.descriptionNl,
            courseForm.value.descriptionEs,
            courseForm.value.descriptionPt,
            courseForm.value.created,
            courseForm.value.createdBy,
            courseForm.value.id,
            null
          )
        );
      }
    }
    this.schoolService.selectedSchool.courseList = newCourseList;
    this.httpService.putSchool(this.schoolService.selectedSchool).subscribe(school => {
      this.schoolService.selectedSchool = school;
      this.schoolService.updatingSchool = false;
      console.log("success");
      this.toastService.addSuccess("updated", "school is successfully updated.");
      this.schoolService.initCourseForm();
    }, error => {
      this.schoolService.updatingSchool = false;
      this.toastService.addError("error", "update failed...")
      console.error(error);
    });
  }

  get courseFormArray(){
    let courseFormArray = this.schoolService.schoolForm.get('courses') as FormArray;
    return courseFormArray.controls;
  }

}
